import { StateManager } from "../states/statemanager";
import type { GameContext, GameMiddleware } from "./types";

/**
 * Drives StateManager each frame.
 *
 * Replaces the duplicated `StateManager.update(delta)` calls that previously
 * existed in both core.ts (renderFrame) and rose-editor.ts (onUpdate).
 *
 * The initial state switch (StateManager.prepareAndSwitch) is intentionally
 * kept in the entry point (core.ts) because it depends on runtime config.
 */
export class StateMiddleware implements GameMiddleware {
    init(_ctx: GameContext): void {
        // Initial state switching is handled by the entry point after game.init().
    }

    update(delta: number): void {
        StateManager.update(delta);
    }
}
